import { render, staticRenderFns } from "./CommunityCompanySanjaeReply.vue?vue&type=template&id=516c41c1"
import script from "./CommunityCompanySanjaeReply.vue?vue&type=script&lang=js"
export * from "./CommunityCompanySanjaeReply.vue?vue&type=script&lang=js"
import style0 from "./CommunityCompanySanjaeReply.vue?vue&type=style&index=0&id=516c41c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports